import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import purchaseOrderService from "./services/purchaseOrderService";

const PurchaseOrderPrint = () => {

  const { id } = useParams();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    if (id) {
      loadPO();
    }

  }, [id]);

  const loadPO = async () => {

    try {

      setLoading(true);

      const res =
        await purchaseOrderService.getPODetail(id);

      if (res.success) {
        setData(res.data);
      }

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }
  };

  if (loading) {
    return <div>Loading Purchase Order...</div>;
  }

  if (!data) {
    return <div>Purchase Order not found</div>;
  }

  const styles = {

    page: {
      background: "#ffffff",
      padding: "24px",
      fontFamily: "Inter, Arial, sans-serif",
      color: "#1e293b"
    },

    card: {
      border: "1px solid #e2e8f0",
      borderRadius: "12px",
      background: "#ffffff",
      marginBottom: "16px",
      overflow: "hidden"
    },

    header: {
      background: "#eef2ff",
      color: "#4338ca",
      padding: "10px 16px",
      fontWeight: 600,
      borderBottom: "1px solid #dbeafe"
    },

    body: {
      padding: "16px"
    }

  };

  return (
    <div style={styles.page}>

      {/* COMPANY HEADER */}

      <div style={styles.card}>

        <div style={styles.body}>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >

            <div>

              <div
                style={{
                  width: 80,
                  height: 80,
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                LOGO
              </div>

            </div>

            <div style={{ textAlign: "right" }}>

              <h2
                style={{
                  margin: 0,
                  color: "#1e293b"
                }}
              >
                COMPANY NAME
              </h2>

              <div>Company Address</div>

              <div>GSTIN : XXXXXXXX</div>

              <div>support@company.com</div>

            </div>

          </div>

        </div>

      </div>

      {/* PURCHASE ORDER TITLE */}

      <div
        style={{
          textAlign: "center",
          marginBottom: 20
        }}
      >

        <h1
          style={{
            margin: 0,
            color: "#1e293b",
            letterSpacing: 1
          }}
        >
          PURCHASE ORDER
        </h1>

        <div
          style={{
            color: "#64748b",
            marginTop: 6
          }}
        >
          {data.po_no}
        </div>

      </div>

      {/* TEMP TEST */}

      <div style={styles.card}>
        <div style={styles.body}>
          <strong>PO ID:</strong> {id}
          <br />
          <strong>PO No:</strong> {data.po_no}
        </div>
      </div>

      {/* PO HEADER */}

      {/* VENDOR */}

      {/* REFERENCES */}

      {/* MATERIAL TABLE */}

      {/* GST SUMMARY */}

      {/* TOTALS */}

      {/* TERMS */}

      {/* SIGNATURE */}

    </div>
  );
};

export default PurchaseOrderPrint;